exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attrcont[data-v-5b224d38]{position:relative;min-height:700px}.attrcontzzc[data-v-5b224d38]{position:absolute;top:0;right:0;left:0;bottom:0;background:#fff}.lajitongdiv[data-v-5b224d38]{position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b224d38","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/attributeform.vue
// module id = 51
// module chunks = 0